import MDBox from "components/MDBox"
import { Tooltip } from "@mui/material"
import { RemoveRedEye } from "@mui/icons-material"

import "./custom.css"
import MDTypography from "components/MDTypography"
import DataTable from "examples/Tables/DataTable"

import { boxListStyle, tableStyle } from "./style"
import { useEffect, useState } from "react"
import { actions } from "./data"
import PropTypes from "prop-types"
import moment from "moment"

function TableContent({
  data,
  dataClass,
  page,
  setPage,
  setTotalPage,
  handlePrev,
  handleNext,
  currentPage,
  setCurrentPage,
  isLoading,
  isEmpty,
}) {
  const listDataClass = dataClass?.data?.data || []
  const listStudentAtRisk = data?.data?.data || []
  const classCodePresent = listStudentAtRisk[0]?.classCode
  const totalPage = data?.data?.totalPage ?? 0
  const [dataTable, setDataTable] = useState({
    columns: [
      { Header: "Student", accessor: "student", width: "12%" },
      { Header: "Student code", accessor: "studentCode", width: "10%" },
      { Header: "Nickname", accessor: "nickname", width: "8%" },
      { Header: "Class", accessor: "class", width: "10%" },

      { Header: "Status", accessor: "overallStatus", width: "8%" },

      { Header: "At-risk criteria", accessor: "atRiskCriteria", width: "12%" },
      {
        Header: "On-track criteria",
        accessor: "ontrackCriteria",
        width: "12%",
      },
      {
        Header: "Off-track criteria",
        accessor: "offtrackCriteria",
        width: "12%",
      },
      {
        Header: "Excelling criteria",
        accessor: "excellingCriteria",
        width: "12%",
      },

      { Header: "Duration", accessor: "duration", width: "6%" },
      { Header: "Time start", accessor: "timeRangeStart", width: "9%" },
      { Header: "Time end", accessor: "timeRangeEnd", width: "9%" },

      { Header: "Suggestion action", accessor: "suggest", width: "10%" },
    ],

    rows: [],
  })

  useEffect(() => {
    if (data) {
      const customDataRow = [...listStudentAtRisk].map((item) => {
        const tooltipContent = item?.suggestedActions || null

        return {
          id: item?.id,
          student: item?.studentName,
          nickname: item?.nickname ?? "",
          studentCode: item?.studentCode,
          class: item?.className,
          classCode: item?.classCode,
          classId: item?.classId,
          hubStudentId: item?.hubStudentId,
          teacherId: item?.teacherId,
          overallStatus: item?.overallStatus ?? "",
          atRiskCriteria: item?.atRiskCriteria ?? "",
          ontrackCriteria: item?.ontrackCriteria ?? "",
          offtrackCriteria: item?.offtrackCriteria ?? "",
          excellingCriteria: item?.excellingCriteria ?? "",
          criteria: item?.atRiskCriteria ?? "",
          duration: item?.durationUnits ?? 0,
          timeRangeStart: moment(item?.timeRangeStart).format("HH:mm"), // item?.timeRangeStart ?? "",
          timeRangeEnd: moment(item?.timeRangeEnd).format("HH:mm"), // item?.timeRangeEnd ?? "",
          suggest: item?.suggestedActions ? (
            <Tooltip
              arrow={false}
              placement="left"
              title={item.suggestedActions}
            >
              <MDTypography sx={{ cursor: "pointer" }}>
                <RemoveRedEye />
              </MDTypography>
            </Tooltip>
          ) : (
            <MDTypography sx={{ cursor: "pointer" }}>
              <RemoveRedEye />
            </MDTypography>
          ),
        }
      })
      setDataTable((dataTable) => ({
        ...dataTable,
        rows: customDataRow || [],
      }))
    }
  }, [data])

  const renderSuggestions = (items, timeRange) => {
    return items.map((item, key) => {
      const itemKey = `element-${key}`
      let result
      if (item === "performanceStatus") {
        result = actions
          .filter(
            (action) => action["Offtrack category"] === "Performance Offtrack"
          )
          .reduceRight(
            (greatest, obj) =>
              obj["Offtrack duration"] <= timeRange &&
              (greatest === null ||
                obj["Offtrack duration"] >= greatest["Offtrack duration"])
                ? obj
                : greatest,
            null
          )
      } else if (item === "engagementStatus") {
        result = actions
          .filter((action) => action["Offtrack category"] === "Engagement")
          .reduceRight(
            (greatest, obj) =>
              obj["Offtrack duration"] <= timeRange &&
              (greatest === null ||
                obj["Offtrack duration"] >= greatest["Offtrack duration"])
                ? obj
                : greatest,
            null
          )
      } else if (item === "homeLearningStatus") {
        result = actions
          .filter((action) => action["Offtrack category"] === "Home Learning")
          .reduceRight(
            (greatest, obj) =>
              obj["Offtrack duration"] <= timeRange &&
              (greatest === null ||
                obj["Offtrack duration"] >= greatest["Offtrack duration"])
                ? obj
                : greatest,
            null
          )
      } else return null

      if (!result?.Action) return null

      return (
        <MDTypography
          key={itemKey}
          color="text"
          verticalAlign="middle"
          textAlign="left"
          sx={(theme) => {
            const {
              palette,
              typography,
              breakpoints,
              functions: { pxToRem },
            } = theme

            return {
              fontFamily: typography.lexendFont,
              fontSize: 14,
              fontWeight: 600,
              lineHeight: 1.37,
              letterSpacing: pxToRem(-0.8),
              color: palette.white.main,
              marginBottom: "12px",

              [breakpoints.down(1600)]: {
                fontSize: 12,
              },
            }
          }}
        >
          {result?.Action}
        </MDTypography>
      )
    })
  }

  return (
    <MDBox sx={(theme) => tableStyle(theme)}>
      <MDBox sx={(theme) => boxListStyle(theme)}>
        <DataTable
          table={dataTable}
          entriesPerPage={false}
          isSorted={false}
          currentPage={currentPage}
          handlePrev={handlePrev}
          handleNext={handleNext}
          totalPage={totalPage}
          setCurrentPage={setCurrentPage}
          isLoading={isLoading}
          isEmpty={isEmpty}
        />
      </MDBox>
    </MDBox>
  )
}

TableContent.propTypes = {
  data: PropTypes.any,
  dataClass: PropTypes.any,
  page: PropTypes.any,
  setPage: PropTypes.any,
  setTotalPage: PropTypes.any,
  handlePrev: PropTypes.any,
  handleNext: PropTypes.any,
  currentPage: PropTypes.any,
  setCurrentPage: PropTypes.func,
  isLoading: PropTypes.bool,
  isEmpty: PropTypes.bool,
}

export default TableContent
